import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { NGXLogger } from "ngx-logger";
import { Impresa } from "../models/impresa.model";
import { PraticaScuola } from "../models/pratica.scuola.model";
import { DettaglioPraticaScuolaDTO } from "../models/dettaglioPratica.scuola.model";
import { FileCaricatoDTO } from "../models/fileCaricato.model";
import { NotaReworkPratica } from "../models/pratica.nota.scuola.model";
import { NotaPraticaDTO } from "../models/pratica.notaDTO.scuola.model";
import { ModificaPraticaDTO } from "../models/modificaPratica.scuola.model";
import { Centrale } from "../models/centrale.models";
import { SopralluogoFase1DTO } from "../models/dto/sopralluogoFase1.model";
import { PreventivoFase1DTO } from "../models/dto/preventivoFase1.model";
import { BocciaturaConsegnaFase1 } from "../models/dto/bocciaturaFase1.model";
import { EsitoConsegnaInfratel } from "../models/dto/esitoConsegnaInfratel.model";
import { Oda } from "../models/oda.model";
import { Utente } from "../models/utente.model";
import { PfIsReady } from "../models/dto/pfIsReady.model";
import { AppuntamentoFase2 } from "../models/dto/appuntamentoFase2.model";
import { BocciaturaConsegnaFase2 } from "../models/dto/bocciaturaFase2.model";
import { BocciaturaPresidioTIM } from "../models/dto/bocciaturaPresidioTIM.model";
import { BocciaturaConsegnaFase3 } from "../models/dto/bocciaturaFase3.model";
import { Pratica } from "../models/pratica.model";
import { DataSopralluogoFase1DTO } from "../models/dto/dataSopralluogoFase1.model";
import { NotaPratica } from "../models/pratica.nota.model";
import { CategoriaVincolo } from "../models/categoriaVincolo.model";
import { Bando2Fase2ExportDTO } from "../models/dto/bando2Fase2Export.model";

@Injectable({
  providedIn: "root",
})
export class PraticheService {
  apiUrl: string = environment.apiUrl + "pratica";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
  ) {}

  richiediCambioCentrale(
    praticaDaModificare: number,
    centrale: Centrale,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + praticaDaModificare + "/fase3/cambio-centrale";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, centrale, httpOptions);
  }

  rigeneraTuttaLaDocumentazione(praticaDaModificare: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + praticaDaModificare + "/fase3/genera-docs";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  creaNota(idPratica: number, nuovaNota: NotaPratica): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/note";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, nuovaNota, httpOptions);
  }
  getNote(idPratica: number): Observable<any> {
    let url = this.apiUrl + "/" + idPratica + "/note";

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getById(idPratica: string): Observable<any> {
    let url = this.apiUrl + "/" + idPratica;

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getByCUI(cui: string): Observable<any> {
    let url = this.apiUrl + "/cui/" + cui;

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  getStorico(idPratica: number): Observable<any> {
    let url = this.apiUrl + "/" + idPratica + "/fase1/storico";

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }
  getStoricoFase2(idPratica: number): Observable<any> {
    let url = this.apiUrl + "/" + idPratica + "/fase2/storico";

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }
  getStoricoFase3(idPratica: number): Observable<any> {
    let url = this.apiUrl + "/" + idPratica + "/fase3/storico";

    const headers = {
      "Content-Type": "application/json",
    };

    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };

    return this.http.get(url, requestOptions);
  }

  resetFase1(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/reset";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  resetFase2(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/reset";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  nascondiFase2(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/nascondi";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  resetFase3(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/reset";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  comunicaDataSopralluogo(
    idPratica: number,
    dataSopralluogo: DataSopralluogoFase1DTO,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/data-sopralluogo";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, dataSopralluogo, httpOptions);
  }

  comunicaEsitoSopralluogo(
    idPratica: number,
    esitoSopralluogo: SopralluogoFase1DTO,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/sopralluogo";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoSopralluogo, httpOptions);
  }

  modificaPreventivo(
    idPratica: number,
    nuovoPreventivo: PreventivoFase1DTO,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/preventivo/modifica";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, nuovoPreventivo, httpOptions);
  }

  approvaPreventivo(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/preventivo/approva";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  rifiutaPreventivo(
    idPratica: number,
    preventivoRifiutato: PreventivoFase1DTO,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/preventivo/rifiuta";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, preventivoRifiutato, httpOptions);
  }

  presidioTIMRifiutaPratica(
    idPratica: number,
    fase: string,
    bocciatura: BocciaturaPresidioTIM,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl +
      "/" +
      idPratica +
      "/fase" +
      fase +
      "/presidioTIMBocciaPratica";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, bocciatura, httpOptions);
  }

  comunicaCaricamentoFilePreventivo(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/preventivo/file-caricato";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  consegnaFase1(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  consegnaFase2(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  consegnaFase3(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  eliminaPratica(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica;
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(urlFinale, httpOptions);
  }
  annullaConsegnaFase1(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(urlFinale, httpOptions);
  }
  annullaConsegnaFase2(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(urlFinale, httpOptions);
  }
  annullaConsegnaFase3(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/consegna";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(urlFinale, httpOptions);
  }
  utentePrendeInCaricoFase1(
    idPratica: number,
    utente: Utente,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/utente-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, utente, httpOptions);
  }

  utentePrendeInCaricoFase2(
    idPratica: number,
    utente: Utente,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/utente-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, utente, httpOptions);
  }

  utentePrendeInCaricoFase3(
    idPratica: number,
    utente: Utente,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/utente-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, utente, httpOptions);
  }

  presidioPrendeInCaricoFase1(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/presidio-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioPrendeInCaricoFase2(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase2/presidio-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioPrendeInCaricoFase3(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/presidio-in-carico";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioValidaConsegnaFase1(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/presidio-valida";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioBocciaConsegnaFase1(
    idPratica: number,
    bocciatura: BocciaturaConsegnaFase1,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/presidio-boccia";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, bocciatura, httpOptions);
  }

  presidioValidaConsegnaFase2(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/presidio-valida";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioBocciaConsegnaFase2(
    idPratica: number,
    bocciatura: BocciaturaConsegnaFase2,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/presidio-boccia";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, bocciatura, httpOptions);
  }

  presidioValidaConsegnaFase3(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/presidio-valida";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioBocciaConsegnaFase3(
    idPratica: number,
    bocciatura: BocciaturaConsegnaFase3,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/presidio-boccia";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, bocciatura, httpOptions);
  }

  modificaCodiceInvio(
    praticaDaModificare: ModificaPraticaDTO,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl +
      "/" +
      praticaDaModificare.id +
      "/fase3/modifica-codice-invio";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, praticaDaModificare, httpOptions);
  }

  comunicaOrdineEsecuzione(praticaDaModificare: Pratica): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + praticaDaModificare.id + "/fase3/ordine-esecuzione";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, praticaDaModificare, httpOptions);
  }
  completaPratica(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/completa";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, httpOptions);
  }
  confermaCaricamentoVerbale(idPraticaDaModificare: number): Observable<any> {
    const urlFinale =
      this.apiUrl +
      "/" +
      idPraticaDaModificare +
      "/fase3/caricamento-verbale-firmato";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  rendiLavorabilePraticaKO(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/rendi-lavorabile";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  presidioTIMModificaDateEsitoConsegnaFase1(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/modifica-date-esito";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }
  presidioTIMComunicaEsitoConsegnaFase1(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase1/comunica-esito";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }
  presidioTIMComunicaInvioAdInfratelFase1(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase1/comunica-invio-infratel";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }
  presidioTIMComunicaInvioAdInfratelFase2(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase2/comunica-invio-infratel";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }
  presidioTIMComunicaInvioAdInfratelFase3(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/comunica-invio-infratel";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }

  presidioTIMComunicaEsitoConsegnaFase2(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/comunica-esito";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }

  comunicaAppuntamentoFase2(
    idPratica: number,
    dataAppuntamento: AppuntamentoFase2,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase2/appuntamento";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, dataAppuntamento, httpOptions);
  }
  modificaDataAttivazioneFase2(
    idPratica: number,
    dataAttivazione: AppuntamentoFase2,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase2/modifica-data-attivazione";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, dataAttivazione, httpOptions);
  }

  modificaCategoriaKO(
    idPratica: number,
    nuovaCategoria: CategoriaVincolo,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/ko/modifica-categoria-vincolo";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, nuovaCategoria, httpOptions);
  }

  modificaStatoPratica(
    idPratica: number,
    idNuovoStato: number,
    fase: number,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl +
      "/" +
      idPratica +
      "/fase" +
      fase +
      "/modifica-stato/" +
      idNuovoStato;
    this.logger.info(urlFinale);
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  assegnaODA(idPratica: number, oda: Oda): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/assegna-oda";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(urlFinale, oda, httpOptions);
  }

  iniziaProgettazione(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/inizia-progettazione";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }
  concludiProgettazione(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/fine-progettazione";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  modifica(praticaDaModificare: ModificaPraticaDTO): Observable<any> {
    const urlFinale = this.apiUrl + "/" + praticaDaModificare.id;
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(urlFinale, praticaDaModificare, httpOptions);
  }

  caricaDettagliPratica(
    dettaglioPraticaDTO: DettaglioPraticaScuolaDTO,
  ): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + dettaglioPraticaDTO.id + "/fase3/dettagli";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, dettaglioPraticaDTO, httpOptions);
  }

  generaDocsFase3(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/genera-docs";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  modificaModelloIRU(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/modifica-modello-iru";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  modificaModelloSUBIRU(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/modifica-modello-subiru";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  confermaCaricamentoPlanimetria(
    idPratica: number,
    estensioneFile: String,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/file/planimetria";
    let fileDTO: FileCaricatoDTO = new FileCaricatoDTO();
    fileDTO.estensione = estensioneFile;
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, fileDTO, httpOptions);
  }

  confermaCaricamentoPacchetto(idPratica: number): Observable<any> {
    const urlFinale =
      this.apiUrl + "/" + idPratica + "/fase3/caricamento-pacchetto-firmato";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  presidioTIMComunicaEsitoConsegnaFase3(
    idPratica: number,
    esitoConsegna: EsitoConsegnaInfratel,
  ): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/comunica-esito";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, esitoConsegna, httpOptions);
  }

  generaShape(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/genera-shape";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  downloadShape(idPratica: number): Observable<Blob> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/download-shape";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
      responseType: "blob" as "json",
    };
    return this.http.get<Blob>(urlFinale, httpOptions);
  }

  getBando2Fase2Export(): Observable<Bando2Fase2ExportDTO[]> {
    const url = this.apiUrl + "/bando2/export";
    const headers = {
      "Content-Type": "application/json",
    };
    const requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    return this.http.get<Bando2Fase2ExportDTO[]>(url, requestOptions);
  }

  exportLunghezzaIru2(): Observable<Blob> {
    const url = this.apiUrl + "/bando2/fase3/export-lunghezza-iru";
    const httpOptions = {
      headers: {},
      reportProgress: true,
      responseType: "blob" as "json",
    };
    return this.http.get<Blob>(url, httpOptions);
  }

  rigeneraDocsPraticaCompleta(idPratica: number): Observable<any> {
    const urlFinale = this.apiUrl + "/" + idPratica + "/fase3/rigenera-docs";
    const headers = {};
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(urlFinale, null, httpOptions);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError = <T>(operation = "operation", result?: T) => {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
